export default function AboutSection() {
  return (
    <section className="relative w-full bg-background-100 py-28 md:py-36 lg:py-44 px-8 md:px-16 lg:px-24">
      <div className="max-w-[1400px] mx-auto">
        <span className="text-xs md:text-[13px] uppercase tracking-[0.2em] text-primary-400 font-label">
          / About
        </span>

        <div className="flex flex-col lg:flex-row mt-16 md:mt-20">
          <div className="lg:w-[45%]"></div>
          <div className="lg:w-[55%]">
            <p className="text-[clamp(22px,3.2vw,36px)] font-light text-primary-600 leading-[1.6] font-heading">
              The team follows modern software engineering practices, including clean architecture, performance optimization, and user-centered design. Every system is built to be scalable, maintainable, and ready for long-term evolution.
            </p>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between mt-24 md:mt-32">
          <span className="text-xs md:text-sm text-foreground-400 font-label">
            &bull; Approach
          </span>

          <div className="flex items-center gap-2 mt-6 lg:mt-0">
            <div className="flex -space-x-2">
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-500 flex items-center justify-center">
                <div className="w-6 h-6 md:w-7 md:h-7 rounded-full border-2 border-background-50"></div>
              </div>
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-400 flex items-center justify-center">
                <div className="w-4 h-4 md:w-5 md:h-5 bg-background-50/80 rotate-45"></div>
              </div>
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-300 flex items-center justify-center">
                <div className="w-6 h-6 md:w-7 md:h-7 rounded-full border-2 border-primary-600"></div>
              </div>
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-200 flex items-center justify-center">
                <div className="flex gap-[3px]">
                  <div className="w-[5px] h-[14px] bg-primary-600 rounded-sm"></div>
                  <div className="w-[5px] h-[20px] bg-primary-600 rounded-sm"></div>
                  <div className="w-[5px] h-[10px] bg-primary-600 rounded-sm"></div>
                </div>
              </div>
            </div>
            <span className="text-sm md:text-base text-primary-600 font-heading font-light ml-4">
              Continuous innovation drives everything
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}